import joi from 'joi';
import { TEXT_FIELD_SIZE } from '../utils';

export const fontSchema = joi.object({
  id: joi.string().optional(),
  type: joi.string().required(),
  name: joi.string().max(TEXT_FIELD_SIZE).required(),
  settings: joi
    .when('type', {
      is: 'google',
      then: joi
        .object({
          link: joi.custom((value: string, helpers) => {
            const links = value.match(/(https?:\/\/[^"]*)/g);
            const linkURL = links ? links.filter(link => link.includes('family')).pop() : undefined;

            return linkURL ? linkURL : helpers.error('linkUrl');
          }),
          cssRule: joi.string().required(),
        })
        .required(),
      otherwise: joi
        .object({
          ttf: joi.string().optional().empty(''),
          otf: joi.string().optional().empty(''),
          woff: joi.string().optional().empty(''),
        })
        .min(1)
        .required(),
    })
    .required(),
});
